import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import './Layout.css';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  const handleLogout = () => {
    logout();
    toast.success('Sesión cerrada exitosamente');
    navigate('/');
  };

  const toggleUserDropdown = () => {
    setShowUserDropdown(!showUserDropdown);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const getUserInitial = () => {
    return user?.full_name?.charAt(0).toUpperCase() || 'U';
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Navbar Superior */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow">
        <div className="container-fluid">
          {/* Logo/Brand */}
          <a className="navbar-brand fw-bold" href="/">
            <i className="bi bi-database-gear me-2"></i>
            DataExtractor
          </a>

          {/* Toggle button para móvil */}
          <button 
            className="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

      {/* Menú de navegación */}
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav me-auto">
          <li className="nav-item">
            <a 
              className={`nav-link ${isActive('/')}`}
              href="/"
            >
              <i className="bi bi-house-door me-1"></i>
              Inicio
            </a>
          </li>
          <li className="nav-item">
            <a 
              className={`nav-link ${isActive('/extractor')}`}
              href="/extractor"
            >
              <i className="bi bi-download me-1"></i>
              Extraer Datos
            </a>
          </li>
          <li className="nav-item">
            <a 
              className={`nav-link ${isActive('/comprar-documentos')}`}
              href="/comprar-documentos"
            >
              <i className="bi bi-cart-plus me-1"></i>
              <span className="d-none d-lg-inline">Comprar Documentos</span>
              <span className="d-lg-none">Comprar</span>
            </a>
          </li>

          <li className="nav-item">
            <a 
              className={`nav-link ${isActive('/configuracion')}`}
              href="/configuracion"
            >
              <i className="bi bi-gear me-1"></i>
              Configuración
            </a>
          </li>
          {/* Mostrar solo si NO hay usuario autenticado */}
          {!user && (
            <li className="nav-item">
              <a className={`nav-link ${isActive('/register')}`} href="/register">
                <i className="bi bi-person-plus me-1"></i>
                Registrarse
              </a>
            </li>
          )}
        </ul>

            {/* Área de Usuario */}
            <div className="navbar-nav">
              <div className="nav-item dropdown">
                <button
                  className="btn btn-outline-light dropdown-toggle d-flex align-items-center"
                  type="button"
                  onClick={toggleUserDropdown}
                  data-bs-toggle="dropdown"
                >
                  {/* Avatar del usuario */}
                  <div 
                    className="rounded-circle bg-light text-primary d-flex align-items-center justify-content-center me-2"
                    style={{ width: '32px', height: '32px', fontSize: '14px', fontWeight: 'bold' }}
                  >
                    {getUserInitial()}
                  </div>
                  <span className="d-none d-md-inline">{user?.full_name}</span>
                </button>

                {/* Dropdown del Usuario */}
                <ul className={`dropdown-menu dropdown-menu-end ${showUserDropdown ? 'show' : ''}`}>
                  {/* Información del usuario */}
                  <li>
                    <div className="dropdown-header">
                      <div className="fw-bold">{user?.full_name}</div>
                      <small className="text-muted">{user?.email}</small>
                      <div className="mt-1">
                        <span className={`badge ${user?.is_active ? 'bg-success' : 'bg-danger'}`}>
                          {user?.is_active ? 'Activo' : 'Inactivo'}
                        </span>
                      </div>
                    </div>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  
                  {/* Opciones del usuario */}
                  <li>
                    <a className="dropdown-item" href="/profile">
                      <i className="bi bi-person me-2"></i>
                      Mi Perfil
                    </a>
                  </li>
                  
                  {/* Solo mostrar para administradores */}
                  {user?.role === 'admin' && (
                    <li>
                      <a className="dropdown-item" href="/admin/users">
                        <i className="bi bi-people me-2"></i>
                        Usuarios
                      </a>
                    </li>
                  )}
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <button 
                      className="dropdown-item text-danger" 
                      onClick={handleLogout}
                    >
                      <i className="bi bi-box-arrow-right me-2"></i>
                      Cerrar Sesión
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Contenido Principal */}
      <main className="flex-grow-1 bg-light">
        <div className="container-fluid py-4">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-dark text-light py-3 mt-auto">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <p className="mb-0">
                <i className="bi bi-c-circle me-1"></i>
                2025 Titanius Consulting S.R.L. Todos los derechos reservados.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <small className="">
                Versión Beta 1.0.0
              </small>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
